import ChannelTable from "./ChannelTable";

const Channel = () => {
  return (
    <>
      <ChannelTable />
    </>
  );
};

export default Channel;
